import base from 'components/base'
import componentInit from 'components/componentInit'
import main from 'main'
import $ from 'jquery'

import 'jquery.easing'
import 'jquery.scrollto'
import 'jquery-sizes'

class polls extends base
{
  elements = {
    container: null,
    modeTitle: null,
    items: [],
    itemImages: [],
    itemTitles: [],
    pollForm: null,
    closeReviewButton: null,
    columnPlaceholders: [],
    drawForm: null,
    siteContent: null,
    contentElements: []
  }

  animating = false
  enabled = true
  mode = 'base'

  constructor(element)
  {
    super()

    this.elements.container = $(element).get(0)
    this.elements.modeTitle = $(this.elements.container).find('.mode-title').get(0)
    this.elements.items = $(this.elements.container).find('.item').get()
    this.elements.itemImages = $(this.elements.items).find('.image').get()
    this.elements.itemTitles = $(this.elements.items).children('.wrapper').children('.title').get()
    this.elements.pollForm = $(this.elements.container).find('form.poll-form').get(0)
    this.elements.closeReviewButton = $(this.elements.pollForm).find('.close-review').get(0)
    this.elements.drawForm = $(this.elements.container).find('form.custom-form').get(0)

    this.elements.siteContent = $(this.elements.container).closest('#site-content').get(0)
    this.elements.contentElements = $(this.elements.siteContent).find('main.content').get()

    this.enabled = !$(this.elements.container).hasClass('disabled')

    this.bindEvents()
  }

  bindEvents()
  {
    $(this.elements.itemImages).on('click.'+ module.id, (event) => {
      if(this.enabled && this.mode === 'base' && !this.animating)
        this.toggleItemSelection($(event.currentTarget).closest('.item'))
    })

    $(this.elements.itemTitles).on('click.'+ module.id, (event) =>
    {
      if(this.mode === 'base' && !this.animating)
        this.openItem($(event.currentTarget).closest('.item'))
    })

    $(this.elements.pollForm).on('submit.'+ module.id, (event) =>
    {
      event.preventDefault()

      if(this.enabled && this.mode === 'base' && !this.animating)
        this.openReviewView()
      else if(this.enabled && this.mode === 'review' && !this.animating)
        this.submitVote()
    })

    $(this.elements.closeReviewButton).on('click.'+ module.id, (event) =>
    {
      event.preventDefault()

      if(this.enabled && this.mode === 'review' && !this.animating)
        this.closeReviewView()
    })

    $(this.elements.container).on('click.'+ module.id, 'button.yes', (event) =>
    {
      event.preventDefault()

      if(this.mode === 'voteSubmitted' && !this.animating)
        this.openDrawView()
    })

    $(this.elements.container).on('click.'+ module.id, 'button.no', (event) =>
    {
      event.preventDefault()

      if(this.mode === 'voteSubmitted' && !this.animating)
        this.openNoDrawView()
    })

    // First disable submit event callback set by kustantajat/components/form or
    // any other component. Then set our submit event callback.
    $(this.elements.drawForm).off('submit')
    $(this.elements.drawForm).on('submit.'+ module.id, (event) =>
    {
      event.preventDefault()

      if(this.enabled && this.mode === 'draw' && !this.animating)
        this.submitDraw()
    })
  }

  toggleItemSelection(item)
  {
    let inputElement = $(item).find('input[type=radio]').get(0)
    if($(inputElement).is(':checked'))
      this.unselectItem(item)
    else
      this.selectItem(item)
  }

  selectItem(item)
  {
    let categoryClass = $(item).attr('class').match(/category-[0-9]+/)
    if(categoryClass && categoryClass[0])
    {
      $(this.elements.items).filter('.'+ categoryClass[0]).not(item).toggleClass('selected', false)
    }

    $(item).toggleClass('selected', true)

    let inputElement = $(item).find('input[type=radio]').get(0)
    $(inputElement).click()
  }

  unselectItem(item)
  {
    $(item).toggleClass('selected', false)

    let inputElement = $(item).find('input[type=radio]').get(0)
    $(inputElement).prop('checked', false)
    $(inputElement).prop('checked', false)
  }

  toggleOpenState(item)
  {
    if($(item).hasClass('open'))
      this.closeItem(item)
    else
      this.openItem(item)
  }

  openItem(item)
  {
    this.animating = true

    let narrowScreen = window.matchMedia('(max-width: 480px)').matches

    let rowClass = $(item).attr('class').match(/row-[0-9]+/)[0]
    let otherItemsOnThisRow = $(this.elements.items).filter('.'+ rowClass).not(item).get()

    let fullRow = this.buildFullRowElement(item)

    let itemTitles = []
    if(narrowScreen)
      itemTitles = $(item).find('.title').get()
    else
      itemTitles = $(item).add(otherItemsOnThisRow).find('.title').get()

    // This defeats the visual glitch of item shrinking and then suddenly
    // growing in size when item title becomes absolutely positioned and full
    // row element appears.
    $(fullRow).css({
      opacity: 0,
      minHeight: $(item).height() - $(item).find('.image').height()
    })

    $(itemTitles).css({
      position: 'absolute',
      marginTop: $(item).find('.image').margin().bottom
    })

    $(fullRow).insertAfter(item)

    $(item).toggleClass('open', true)

    if(!narrowScreen)
      $(otherItemsOnThisRow).toggleClass('open', false)

    $(otherItemsOnThisRow).toggleClass('other-item-opening', true)

    Promise.all([
      $(fullRow).animate({
        opacity: 1
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise(),
      $(itemTitles).animate({
        opacity: 0
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise()
    ])
    .then(() =>
    {
      $(otherItemsOnThisRow).toggleClass('other-item-open', true).toggleClass('other-item-opening', false)
      this.animating = false
    })
  }

  closeItem(item)
  {
    this.animating = true

    let narrowScreen = window.matchMedia('(max-width: 480px)').matches

    let rowClass = $(item).attr('class').match(/row-[0-9]+/)[0]
    let itemsOnThisRow = $(this.elements.items).filter('.'+ rowClass).get()
    let otherItemsOnThisRow = $(itemsOnThisRow).not(item).get()

    let fullRow = null

    fullRow = $(item).next('.full-row.'+ rowClass).get(0)

    let fullRowPosition = $(fullRow).position()

    let itemTitles = $(otherItemsOnThisRow).not('.open').add(item).find('.title').get()

    // Keep space reserved for the full row element occupied until the full row
    // element has been faded out.
    //$(item).css({
      //minHeight: $(item).height() + $(fullRow).height()
    //})

    // Keep full row element in place.
    $(fullRow).css({
      position: 'absolute',
      top: fullRowPosition.top,
      width: $(fullRow).width()
    })

    $(itemTitles).css({
      position: 'static',
      marginTop: 0
    })

    $(item).toggleClass('open', false)

    if($(itemsOnThisRow).filter('.open').get().length === 0)
      $(itemsOnThisRow).toggleClass('other-item-open', false)

    Promise.all([
      $(fullRow).animate({
        opacity: 0
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise(),
      $(itemTitles).animate({
        opacity: 1
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise()
    ])
    .then(() =>
    {
      $(fullRow).remove()
      //$(itemsOnThisRow).css({
        //minHeight: 'auto'
      //})

      $(itemTitles).css({
        position: '',
        opacity: '',
        marginTop: ''
      })

      this.animating = false
    })
  }

  buildFullRowElement(item)
  {
    let rowClass = $(item).attr('class').match(/row-[0-9]+/)[0]
    let fullRow = $('<div class="full-row '+ rowClass +'"><div class="wrapper"><button class="close"><div class="title">'+ main.framework.dict.default.close +'</div><div class="icon"></div></button></div></div>').get(0)
    $(item).children('.wrapper').children('.text').clone().appendTo($(fullRow).children('.wrapper'))

    $(fullRow).children('.wrapper').children('.title').css({
      position: '',
      opacity: '',
      marginTop: ''
    })

    $(fullRow).children('.wrapper').children('button').on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      this.closeItem(item)
    })

    return fullRow
  }

  openReviewView()
  {
    let submitButton = $(this.elements.pollForm).find('input[type=submit]').get(0)

    $(this.elements.pollForm).find('.message.error, .message.input-error').remove()

    let selectedItems = $(this.elements.items).filter('.selected').get()

    // At least one item should be selected.
    if(selectedItems.length === 0)
      $('<div class="message error">'+ main.framework.dict.application.atleastOneItemShouldBeSelected +'</div>')
        .insertBefore(submitButton)

    else
    {
      this.animating = true
      this.mode = 'review'

      // Add column placeholder elements for columns that do not have an
      // selected item.
      let occupiedColumns = []
      let maxColumn = null
      for(let item of selectedItems)
      {
        let column = $(item).attr('class').match(/column-([0-9]+)/)
        if(column && column[1])
        {
          column = parseInt(column[1])
          occupiedColumns.push(column)

          if(!maxColumn || column > maxColumn)
            maxColumn = column
        }
      }

      for(let c = 1; c <= maxColumn; c++)
      {
        if(occupiedColumns.indexOf(c) !== -1)
          continue

        let lastColumnItem = $(this.elements.items).filter('.column-'+ c).get(-1)
        let columnPlaceholder = $('<div class="column-placeholder column-'+ c +'"><div class="wrapper"></div></div>').get(0)
        $(columnPlaceholder).insertAfter(lastColumnItem)
        this.elements.columnPlaceholders.push(columnPlaceholder)
      }

      let elementsToFadeIn = $(this.elements.pollForm).find('.fields')
        .add(this.elements.modeTitle)
        .add(this.elements.closeReviewButton)

      $(elementsToFadeIn).css({
        display: '',
        opacity: 0
      })

      let elementsToSlideUp = $(this.elements.container).find('.items')
        .children(':not(.selected):not(.column-placeholder):not(.category-title)')

      let parents = $(this.elements.container).parentsUntil(this.elements.contentElements).get()
      elementsToSlideUp = $(elementsToSlideUp).add($(this.elements.contentElements).children().not(parents).not(this.elements.container))

      $(submitButton).val(main.framework.dict.application.confirm)
      $(this.elements.container).toggleClass('vote-review', true).toggleClass('vote-review-order', true)

      let promise = $(elementsToFadeIn).animate({
        opacity: 1
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise()

      $(elementsToSlideUp).slideUp({
        duration: 500,
        easing: 'easeOutExpo',
        complete: () => {
          promise
          .then(() =>
          {
            this.animating = false
          })
        }
      })

      this.scrollToTop()
    }
  }

  closeReviewView()
  {
    this.animating = true
    this.mode = 'base'

    let elementsToFadeOut = $(this.elements.pollForm).find('.fields')
      .add(this.elements.modeTitle)
      .add(this.elements.closeReviewButton)

    let elementsToSlideDown = $(this.elements.container).find('.items')
      .children(':not(.selected):not(.column-placeholder):not(.category-title)')

    let parents = $(this.elements.container).parentsUntil(this.elements.contentElements).get()
    elementsToSlideDown = $(elementsToSlideDown).add($(this.elements.contentElements).children().not(parents).not(this.elements.container))

    $(this.elements.pollForm).find('input[type=submit]').val(main.framework.dict.application.vote)
    $(this.elements.columnPlaceholders).remove()
    this.elements.columnPlaceholders = []
    $(this.elements.container).toggleClass('vote-review-order', false)

    let promise = $(elementsToFadeOut).animate({
      opacity: 0
    }, {
      duration: 500,
      easing: 'easeOutExpo'
    }).promise()
    .then(() =>
    {
      $(elementsToFadeOut).hide()
    })

    $(elementsToSlideDown).slideDown({
      duration: 500,
      easing: 'easeOutExpo',
      complete: () => {
        promise
        .then(() =>
        {
          $(this.elements.container).toggleClass('vote-review', false)
          this.animating = false
        })
      }
    })
  }

  submitVote()
  {
    let method = $(this.elements.pollForm).attr('method')
    let url = $(this.elements.pollForm).attr('action')
    let data = $(this.elements.pollForm).serialize()

    this.runQuery({
      element: this.elements.pollForm,
      type: method,
      url: url,
      input: data,
      events: {
        onSuccess: [(query) =>
        {
          this.animating = true
          this.enabled = false
          this.mode = 'voteSubmitted'

          let elementToFadeIn = $('<div class="draw-question"></div>').get(0)

          let message = query.getMessage()
          if(message)
            $('<div class="message success">'+ message +'</div>')
              .appendTo(elementToFadeIn)

          let drawFormElement = $(this.elements.container).find('form.custom-form').get(0)
          if(drawFormElement)
            $('<div class="buttons"><button class="yes"><div class="icon"></div><div class="title">'+ main.framework.dict.default.yes +'</div></button><button class="no"><div class="icon"></div><div class="title">'+ main.framework.dict.default.no +'</div></button></div>')
              .appendTo(elementToFadeIn)

          $(elementToFadeIn)
            .css({
              display: '',
              opacity: 0,
              position: 'absolute',
              top: 0
            })
            .appendTo(this.elements.container)

          let elementsToFadeOut = [
            this.elements.modeTitle,
            this.elements.pollForm
          ]

          Promise.all([
            $(elementToFadeIn).animate({
              opacity: 1
            }, {
              duration: 500,
              easing: 'easeOutExpo'
            }).promise(),
            $(elementsToFadeOut).animate({
              opacity: 0
            }, {
              duration: 500,
              easing: 'easeOutExpo'
            }).promise()
          ])
          .then(() =>
          {
            $(this.elements.container).toggleClass('vote-submitted', true).toggleClass('vote-review', false).toggleClass('vote-review-order', false)
            this.animating = false
          })

          this.scrollToTop()
        }]
      }
    })
  }

  openDrawView()
  {
    this.animating = true
    this.enabled = true
    this.mode = 'draw'

    let elementsToFadeIn = [
      this.elements.modeTitle,
      this.elements.drawForm
    ]

    let elementToFadeOut = $(this.elements.container).find('.draw-question').get(0)

    $(this.elements.modeTitle).html(main.framework.dict.application.participateInDraw)
    $(this.elements.container).toggleClass('draw', true).toggleClass('vote-submitted', false)

    Promise.all([
      $(elementsToFadeIn).animate({
        opacity: 1
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise(),
      $(elementToFadeOut).animate({
        opacity: 0
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise()
    ])
    .then(() =>
    {
      $(elementToFadeOut).remove()
      this.animating = false
    })
  }

  openNoDrawView()
  {
    this.animating = true
    this.mode = 'noDraw'

    let elementToFadeIn = $('<div class="message success">'+ main.framework.dict.application.pollSuccessMessage +'</div>').get(0)

    $(elementToFadeIn)
      .css({
        opacity: 0
      })
      .appendTo(this.elements.container)

    let elementToFadeOut = $(this.elements.container).find('.draw-question').get(0)

    $(this.elements.container).toggleClass('no-draw', true).toggleClass('vote-submitted', false)

    Promise.all([
      $(elementToFadeIn).animate({
        opacity: 1
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise(),
      $(elementToFadeOut).animate({
        opacity: 0
      }, {
        duration: 500,
        easing: 'easeOutExpo'
      }).promise()
    ])
    .then(() =>
    {
      $(elementToFadeOut).remove()
      this.animating = false
    })
  }

  submitDraw()
  {
    let method = $(this.elements.drawForm).attr('method')
    let url = $(this.elements.drawForm).attr('action')
    let data = $(this.elements.drawForm).serialize()

    this.runQuery({
      element: this.elements.drawForm,
      type: method,
      url: url,
      input: data,
      events: {
        onSuccess: [(query) =>
        {
          this.animating = true
          this.enabled = false
          this.mode = 'drawSubmitted'

          let elementToFadeIn = $('<div class="message success">'+ main.framework.dict.application.pollAndDrawSuccessMessage +'</div>').get(0)

          $(elementToFadeIn)
            .css({
              opacity: 0,
              position: 'absolute',
              top: 0
            })
            .appendTo(this.elements.container)

          let elementsToFadeOut = [
            this.elements.modeTitle,
            this.elements.drawForm
          ]

          Promise.all([
            $(elementToFadeIn).animate({
              opacity: 1
            }, {
              duration: 500,
              easing: 'easeOutExpo'
            }).promise(),
            $(elementsToFadeOut).animate({
              opacity: 0
            }, {
              duration: 500,
              easing: 'easeOutExpo'
            }).promise()
          ])
          .then(() =>
          {
            $(this.elements.container).toggleClass('draw-submitted', true).toggleClass('draw', false)
            this.animating = false
          })

          this.scrollToTop()
        }]
      }
    })
  }

  scrollToTop()
  {
    let params = {
      axis: 'y',
      duration: 1000,
      easing: 'easeOutExpo'
    }

    $.scrollTo(0, params)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  let elements = $(parentElement).find('.poll').get()
  for(let element of elements)
    new polls(element)
}

export default polls



// WEBPACK FOOTER //
// ./applications/publicFrontend/scripts/components/polls.js